import { useController } from 'react-hook-form';
import { InputGroup, DateRangePicker } from 'rsuite';
import { FormGroup } from '@shared/ui/forms/display';
import { icons } from '@shared/static/icons';
import { customDateRanges } from '@utils/date-helpers';
import { useTranslation } from 'react-i18next';
import { theme } from '@utils/libs/theme';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function DateRangeInput({ control, name, label }) {
  const { t } = useTranslation();
  const isMobileSm = useMediaQuery(theme.breakpoints.down('sm'));
  const { field } = useController({ control, name });

  const ranges = customDateRanges.map((range) => ({
    label: t(range.label),
    value: range.value,
  }));

  return (
    <FormGroup label={label}>
      <InputGroup inside className={field.value ? 'has-value' : ''}>
        <InputGroup.Addon>{icons.calendar}</InputGroup.Addon>
        <DateRangePicker
          block
          className="datepicker"
          placement="auto"
          showOneCalendar={isMobileSm}
          caretAs={null}
          ranges={ranges}
          placeholder={t('select_date')}
          showHeader={false}
          value={field.value ?? null}
          onChange={(value) => field.onChange(value)}
        />
      </InputGroup>
    </FormGroup>
  );
}
